import posthog from 'posthog-js';

type AnalyticsUser = {
  sub?: string;
  email?: string;
  name?: string;
  nickname?: string;
};

const key = import.meta.env.VITE_POSTHOG_KEY;
const host = import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com';

export function initPostHog() {
  if (!key) {
    return;
  }

  posthog.init(key, {
    api_host: host,
    // `defaults` sets modern pageview/pageleave behavior automatically
    // (capture_pageview: 'history_change' + capture_pageleave).
    defaults: '2025-05-24',
    autocapture: true,
    person_profiles: 'identified_only',
  });
}

export function identifyUser(user: AnalyticsUser | null | undefined) {
  if (!key || !user?.sub) {
    return;
  }

  posthog.identify(user.sub, {
    email: user.email,
    name: user.name ?? user.nickname,
  });
}

export function resetUser() {
  if (!key) {
    return;
  }

  posthog.reset();
}
